// extracted by mini-css-extract-plugin
export default {"startButton":"StartButton_startButton__ZYPm8","openStartButton":"StartButton_openStartButton__2Uutd","openButtonDesc":"StartButton_openButtonDesc__O8kiq"};